import {UploadFile} from './uploadFile'
import {Crop} from './crop.js';
import {ActionStack} from './actionStack'

import app from './app.js';
import board from './board.js';
import utils from './utils.js';
import init from './init.js';
import upload from './upload.js';
import exportImg from './exportImg.js';
$(document).ready(function(){
// 语言
if(getQueryVariable('lang')){
    window.i18nWaterMark.global.locale = getQueryVariable('lang')
    localStorage.setItem('lang',getQueryVariable('lang'));
}
// 传图加载
function getObjectURL(file) {
    var url = null ;
    if (window.createObjectURL!=undefined) {
        url = window.createObjectURL(file) ;
    } else if (window.URL!=undefined) {
        url = window.URL.createObjectURL(file) ;
    } else if (window.webkitURL!=undefined) {
        url = window.webkitURL.createObjectURL(file) ;
    }
    return url ;
};
// 判断是否首次进入页面
if(localStorage.getItem('first')){
    app.first=1
}else{
    localStorage.setItem('first',1)
}
/**
 * 图片上传
 *     点击上传
 *     拖拽上传
 */

// 拖拽上传文件
var oWrap=document.querySelector('.edit_box>.uploadBox')
oWrap.ondragover=function (ev) {
    return false;
    //防止默认触发
    ev.preventDefault()
    //防止事件冒泡
    ev.stopPropagation()
};
oWrap.ondrop=function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    uploadImg(ev.dataTransfer.files[0])
};
// 更改图片
var replace_img=0;
$('#upload').change(function() {
    uploadImg($(this)[0].files[0]);
})
function uploadImg(file){
    if(!app.first){
        app.manage('select_first','')
    }else{
        app.manage('select','')
    }
    if(replace_img){
        if(!app.first){
            app.manage('replace_img_first','')
        }else{
            app.manage('replace_img','')
        }
        replace_img=0;
    }
    if (file) {
        app.LoginSuccess();
        var that=$(this);
        $('.edit_box .load').show();
        $('.function_desk').removeClass('active');
        $('.edit_btn').removeClass('active');
        $('.canvas_box').hide();
        $('.edit_box>.uploadBox').hide();
        $('.header .left i').hide()
        $('.header .left label').hide();
        $('.header .mobile_box>label').css({'visibility':'hidden'});
        $('.header .mobile_box .crop_tab').removeClass('show');
        $('.header .mobile_box .down').removeClass('show');
        $('.function_desk_mobile').removeClass('active');
        var data;
        var num = 0;
        var time=setInterval(function(){
            num++
            if(murmur!=1){
                // 清除上次用戶裁剪的状态
                $('.crop').removeClass('active');
                clearInterval(time)
                app.benefitStatus(function(){
                    // utils.closeMask('.photo');
                    app.downJson=null;
                    window.uploadInit(file);
                    that.val('')
                },function(){
                    $('.banner_box>div .btn span,.phone_top i.upload').removeClass('load');
                })
            }else{
                if(num==5){
                    app.manage('e_id_5s','')
                }
                if(num==10){
                    app.manage('e_id_10s','')
                }
            }
        },1000)






        // if(user){
        //     data={
        //         e_id:murmur,
        //         t_id:user.t_id,
        //         token:user.token,
        //         product_id:app.product_id
        //     }
        // }else{
        //     data={
        //         e_id:murmur,
        //         product_id:app.product_id
        //     }
        // }
        // // // 跳过会员权限直接上传
        // // app.subscriptions=[
        // //     {
        // //         "product_feature": -1,
        // //         "since": 0,
        // //         "expire": 0,
        // //         "benefits": [
        // //             {
        // //                 "key": "in_size",
        // //                 "type": "2",
        // //                 "quota": "-1",
        // //                 "threshold": "-1",
        // //                 "limit": "5242880",
        // //                 "usage": 0
        // //             },
        // //             {
        // //                 "key": "in_edge",
        // //                 "type": "2",
        // //                 "quota": "6",
        // //                 "threshold": "1920",
        // //                 "limit": "12288",
        // //                 "usage": 0
        // //             },
        // //             {
        // //                 "key": "out_expire",
        // //                 "type": "3",
        // //                 "quota": "7200",
        // //                 "threshold": null,
        // //                 "limit": null
        // //             },
        // //             {
        // //                 "key": "out_edge",
        // //                 "type": "2",
        // //                 "quota": "6",
        // //                 "threshold": "1080",
        // //                 "limit": "-1",
        // //                 "usage": 0
        // //             },
        // //             {
        // //                 "key": "out_lossless",
        // //                 "type": "3",
        // //                 "quota": "0",
        // //                 "threshold": null,
        // //                 "limit": null
        // //             }
        // //         ]
        // //     }
        // // ]
        // // app.downJson=null;
        // // window.uploadInit(file)
        // // that.val('')
        // // return false;
        // $.post(
        //     post_url+'benefit/status',
        //     data,
        //     function(data){
        //         console.log(data);
        //         error_fn(data.error);
        //         switch(data.error){
        //             case 0:
        //                 app.subscriptions=data.subscriptions;
        //                 console.log(app.subscriptions);
        //                 // utils.closeMask('.photo');
        //                 app.downJson=null;
        //                 window.uploadInit(file)
        //                 that.val('')
        //                 break;
        //             case 26801:
        //                 $('.edit_box .load').hide();
        //                 $('.edit_box>.uploadBox').show();
        //                 error(i18n[lang].error_26801);
        //                 break;
        //             case 26802:
        //                 $('.edit_box .load').hide();
        //                 $('.edit_box>.uploadBox').show();
        //                 error(i18n[lang].error_26802);
        //                 break;
        //             case 26803:
        //                 $('.edit_box .load').hide();
        //                 $('.edit_box>.uploadBox').show();
        //                 error(i18n[lang].error_26803);
        //                 break;
        //             case 26804:
        //                 $('.edit_box .load').hide();
        //                 $('.edit_box>.uploadBox').show();
        //                 error(i18n[lang].error_26804);
        //                 break;
        //         }
        //         if(data.error!=0){
        //             $('.edit_box>.uploadBox').show();
        //         }
        //     }
        // ).fail(function(){
        //     $('.edit_box .load').hide();
        //     $('.edit_box>.uploadBox').show();
        //     overtime(26899);
        // })
    }
}
/**
 * 初始化
 *     初始化canvas对象
 *     上传后初始化canvas大小尺寸
 *     初始化编辑模式
 *     初始化操作记录
 */
window.uploadInit=function(file){
    app.uploadFile_old=file;
    app.uploadFile = new UploadFile()
    app.uploadFile.upload(file, img => {
        initCanvas()
        init.initApp(app.board.canvas, img, app.board.mask)
        $('.edit_btn').addClass('active');
        $('.function_desk').addClass('active');
        $('.canvas_box').show();
        $('.btn>div').eq(0).addClass('active').siblings('div').removeClass('active');
        if (!localStorage.getItem('guide')) {
            localStorage.setItem('guide','true');
            localStorage.setItem('save_guide','true');
            localStorage.setItem('remove_guide','true');
            $('.photo_guide_box').toggleClass('active').css({
                left:$('.edit_btn').offset().left-($('.function_desk').width()+70)
            });
        }
    }, err=> {
        app.manage('loading_results','fail');
    })
};
/**
 * 获取canvas对象并挂载在容器上
 * canvas： 要操作的canvas
 * mask： 生成的黑白蒙版
 * cover： 绘制多边形时使用的临时canvas
 */
function initCanvas() {
    board.canvas = document.querySelector('#RightSaveCanvas')
    board.ctx = board.canvas.getContext('2d')

    board.mask = document.querySelector('#mask')
    board.ctxMask = board.mask.getContext('2d')

    board.cover = document.querySelector('#cover')
    board.ctxCover = board.cover.getContext('2d')

    app.board = board

    if (app.crop) {
        app.crop.destroy()
    }
    app.cropRecord = null
    app.token = ''

    window.onresize = function() {
        board.cover.style.top = board.canvas.offsetTop + 'px'
        board.cover.style.left = board.canvas.offsetLeft + 'px'
        if (app.crop) 
            app.crop.updateContainerSize()
    }
}

/**
 * 切换工具
 */
//阻止冒泡
$('.pensize-change-container').click(function(e){
    e.stopPropagation();
})
//收起画笔大小
$('.pensize-change-container i').click(function(){
    $('.pensize-change-container').hide();
    $('.hb_type .hb.active').addClass('c');
    $('.hb_type .eraser.active').addClass('c');
    hb_pensize=1;
    xp_pensize=1;
})
// 手指滑动屏幕引导手册消失
$('#RightSaveCanvas').on('touchmove',function(event){
    $('.photo_guide_box').removeClass('active');
})
$(document).click(function(){
    if($('.photo_guide_box').css('display')=='none'){
        $('.pensize-change-container').hide();
    }
    $('.hb_type .hb.active').addClass('c');
    $('.hb_type .eraser.active').addClass('c');
    $('.photo_guide_box').removeClass('active');
    $('.save_guide').removeClass('active');
    $('.remove_guide').removeClass('active');
    $('.photo_rights').hide()
    $('.photo_rights_load').hide();
    $('.photo_toggle_box').hide();
    $('.photoHistory_box').removeClass('active');
    $('.header .login ul').hide()
    hb_pensize=1;
    xp_pensize=1;
});
var hb_pensize=1;
var xp_pensize=1;
$('.hb_mobile').click(function(e){
    e.stopPropagation();
    $('.hb').click()
});
$('.hb').click(function(e) {
    console.log(123123);
    e.stopPropagation();
    $(this).addClass('active').siblings().removeClass('active');
    $('.hb_mobile').addClass('active').siblings().removeClass('active');
    $('.move').removeClass('active');
    $('.photo_guide_box').removeClass('active');
    app.model.changeMode(1);
    xp_pensize=1;
    if(hb_pensize){
        if($(window).width()>980){
            $('.pensize-change-container').show().css({'left':$(this).position().left+5});
            if(parseInt($('.function_desk').css('bottom'))<24){
                $('.pensize-change-container').css({'top':'-25px'})
            }else{
                $('.pensize-change-container').css({'top':'50px'})
            }
        }else{
            $('.pensize-change-container').show().css({'top':'30px','left':$('.hb_mobile').offset().left})
        }
        $(this).removeClass('c').siblings().removeClass('c');
        $('.hb_mobile').removeClass('c').siblings().removeClass('c');
        hb_pensize=0;
    }else{
        $('.pensize-change-container').hide();
        $(this).addClass('c').siblings().removeClass('c');
        $('.hb_mobile').addClass('c').siblings().removeClass('c');
        hb_pensize=1;
    }
    
    $('.photo_rights').hide()
    $('.photo_rights_load').hide();
})
$('.free_lasso').click(function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.move').removeClass('active')
    $('.pensize-change-container').hide();
    app.model.changeMode(2)
})
$('.line_lasso').click(function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.move').removeClass('active')
    $('.pensize-change-container').hide();
    app.model.changeMode(3)
})
$('.eraser').click(function(e) {
    $(this).addClass('active').siblings().removeClass('active');
    $('.move').removeClass('active');
    $('.photo_guide_box').removeClass('active');
    app.model.changeMode(4);
    hb_pensize=1;
    if(xp_pensize){
        if($(window).width()>600){
            $('.pensize-change-container').show().css({'left':$(this).position().left+5});
            if(parseInt($('.function_desk').css('bottom'))<24){
                $('.pensize-change-container').css({'top':'-25px'})
            }else{
                $('.pensize-change-container').css({'top':'50px'})
            }
        }else{
            $('.pensize-change-container').show();
        }
        $(this).removeClass('c').siblings().removeClass('c');
        xp_pensize=0;
    }else{
        $('.pensize-change-container').hide();
        $(this).addClass('c').siblings().removeClass('c');
        xp_pensize=1;
    }
    e.stopPropagation();
    $('.photo_rights').hide()
    $('.photo_rights_load').hide();
})
// 拖拽移动
var hbActive;
$('.move').click(function() {
    if (app.model.model == 0) {
        $(this).removeClass('active');
        // 如果是从裁剪状态切换过来的，再次点击进入裁剪状态
        if (app.model.lastModel == 5) {
            changeCropStatus()
        } else {
            // 如果不是从裁剪状态切换过来的，再次点击返回上个编辑模式
            app.model.changeMode(app.model.lastModel)
        }
        hbActive.addClass('active');
    } else {
        $(this).addClass('active');
        app.model.changeMode(0)
        if (app.crop) {
            app.drag.binddragMove(app.board.canvas, app.crop.container)
        } else {
            app.drag.binddragMove(app.board.canvas)    
        }
        hbActive=$('.desk_box .hb_type>div.active');
        $('.desk_box .hb_type>div').removeClass('active');
    }
})

// 上传去水印图片
$('.desk_box .remove').click(function(){
    if (app.actions.getCurrentIndex() == 0) {
        upload.showMessageBox('alertMessage',i18nWaterMark.global.t('watermark_select_area'), false, '', '', true);
    } else {
        if(!app.first){
            app.manage('click_remove_first',"")
        }else{
            app.manage('click_remove',"")
        }
        var modelArr=new Set(app.brush_model)
        var sizelArr=new Set(app.brush_size)
        for(var i of modelArr){
            if(i==4){
                continue;
            }
            app.manage('brush_model',i)
        }
        for(var i of sizelArr){
            console.log(i);
            app.manage('brush_size',i)
        }
        app.brush_model=[];
        app.brush_size=[];
        upload.upload(app.uploadFile_old, app.board.mask);
        app.LoginSuccess();
    }
})


// 图片保存，未裁剪
$('.edit_btn .down').click(function() {
    var c=upload.getDownload(0,[],function(){
        $('.image-loading-box').hide()
		$('.alert-mask').hide()
    });
    if(c==false){
        $('.alert-mask').css({
            'display': 'block',
            'z-index': 5
        })
        $('.image-loading-box').show()
        $('.show-message-box').hide()
        $('.down-alert-box').show();
        $('.down-alert-box .noRemove').show();
        $('.down-alert-box .load').hide();
        $('.down-alert-box .down').hide();
        $('.down-alert-box .info').html(i18nWaterMark.global.t('noRemove_down_btn'));
    }else{
        $('.alert-mask').css({
            'display': 'block',
            'z-index': 5
        })
        $('.image-loading-box').show()
        $('.show-message-box').hide()
        $('.down-alert-box').show();
        $('.down-alert-box .down').show();
        $('.down-alert-box .load').show();
        $('.down-alert-box .info').html(i18nWaterMark.global.t('down_btn'));
        $('.down-alert-box .noRemove').hide();
    }
})
$(".header .mobile_box .down").click(function(){
    $('.edit_btn .down').click();
});
// 切换去水印
$('.back_remove').click(function(){
    $('.edit_btn .back_remove').hide();
    $('.edit_btn .crop_down').hide();
    $('.header .mobile_box .crop_down').hide();

    $('.edit_btn .down').show();
    $('.edit_btn .crop_tab').show();
    $('.header .mobile_box .down').show();

    $('.crop_box').removeClass('active');
    $('.crop_tab').removeClass('active');

    $('.hb_type').show();
    $('.function_desk .remove').show();
    // 如果是从裁剪状态切换过来的，则切换到app里记录的编辑模式
    if (app.model.model == 5) {
        app.model.changeMode(app.beforeCropModel || 3)
    // 如果是从移动状态切换过来的，不切换模式，改变记录的上次编辑模式
    } else if (app.model.model == 0) {
        app.model.lastModel = app.beforeCropModel || 3
    } else {
        app.model.changeMode(app.model.lastModel)
    }
    app.actions.checkBtn()
});
// 切换裁剪
$('.crop_tab').click(function(){
    if($(this).attr('class').indexOf('active')>-1){
        $(this).removeClass('active');
        $('.back_remove').click();
    }else{
        // 如果绘制的对象不为空则返回
        if (app.actions.getCurrentIndex() != 0) {
            upload.showMessageBox('alertMessage',i18nWaterMark.global.t('watermark_remove_not_save'), false, function() {
                app.actions.clear()
                changeCropStatus()
            }, function() {
                return false
            })
        } else {
            changeCropStatus()
        }
    }
});
function changeCropStatus() {
    $('.edit_btn .back_remove').show();
    $('.edit_btn .crop_down').show();
    $('.header .mobile_box .crop_down').show();

    $('.edit_btn .down').hide();
    $('.header .mobile_box .down').hide();
    $('.edit_btn .crop_tab').hide();
    $('.header .mobile_box .crop_tab').addClass('active');
    $('.function_desk .remove').hide();

    $('.crop_box').addClass('active');
    $('.hb_type').hide();
    if (app.model.model != 0 && app.model.model != 5) {
        app.beforeCropModel = app.model.model
    }
    app.model.changeMode(5)

    // 初始化裁剪的撤销恢复
    if (app.cropRecord) {
        app.crop.show()
        app.cropRecord.redo()
        init.setCropBoxSize()
    } else {
        app.crop = new Crop(document.querySelector('.edit_box'), 'cropContainer', 'zxxCropBox', app.board.canvas)
        app.crop.show()
        app.cropRecord = new ActionStack(app.board.canvas, app.board.mask, 'crop')
        app.cropRecord.bindBtn(document.querySelector('.revoke_box .undo'), document.querySelector('.revoke_box .redo'))
        $('.free-crop-ratio').click()
    }

    // right值变化
    var oldRight=parseInt($('.function_desk').css("right"));
    $('.function_desk').css("right",0)
    if(oldRight>$(window).width()-$('.function_desk').outerWidth(true)){
        $('.function_desk').css("right",$(window).width()-$('.function_desk').outerWidth(true))
    }else{
        $('.function_desk').css("right",oldRight)
    }
}

// 选择裁剪尺寸接口，具体实现根据页面来
$('.set-crop-ratio').click(function() {
    $('.set-crop-ratio').removeClass('active')
    $(this).addClass('active').siblings().removeClass('active');
    if ($(this).hasClass('show-res')){
        $('.chose-res p').html($(this).html())
        $('.chose-res').css({
            'border': '1px solid #21a1f2',
            'color': '#21a1f2'
        })
        $('.chose-res i').css('backgroundPositionY','-6px')
    } else {
        $('.chose-res p').html(i18nWaterMark.global.t('watermark_select'))
        $('.chose-res').css({
            'border': '1px solid #000',
            'color': '#000'
        })
        $('.chose-res i').css('backgroundPositionY','-0px')
    }

    if (app.model.model == 0) {
        $('.move').removeClass('active');
        changeCropStatus()
    }

    app.crop.setRatio($(this).attr('data-ratio-width') / $(this).attr('data-ratio-height'))
})

// 图片保存，裁剪
$('.edit_btn .crop_down').click(function() {
    let canvas = app.crop.makeCrop()
    var c=upload.getDownload(1,canvas.crop,function(){
        $('.image-loading-box').hide()
		$('.alert-mask').hide();
    })
    console.log(c);
    // 没有去水印走默认下载
    if(c==false){
        exportImg.save(canvas.canvas)
    }else{
        $('.alert-mask').css({
            'display': 'block',
            'z-index': 5
        })
        $('.image-loading-box').show()
        $('.show-message-box').hide()
        $('.down-alert-box').show();
        $('.down-alert-box .down').show();
        $('.down-alert-box .load').show();
        $('.down-alert-box .info').html(i18nWaterMark.global.t('down_btn'));
        $('.down-alert-box .noRemove').hide();
    }
})
$(".header .mobile_box .crop_down").click(function(){
    $('.edit_btn .crop_down').click();
});
// 点击下载提示框关闭
$('.show-message-box .close').click(function(){
    $('.image-loading-box').hide()
    $('.alert-mask').hide();
});


// 点击切换裁剪尺寸
 $('.chose-res').click(function(e) {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active')
    } else {
        $(this).addClass('active')
    }
    $('.sizeList-box').toggle()
    e.preventDefault()
    e.stopPropagation()
})
document.onclick = function() {
    if ($('.chose-res').hasClass('active')) {
        $('.sizeList-box').toggle()
        $('.chose-res').removeClass('active')
    }
}


let sizeListTranslate = 0
let barTop= 4
$('.sizeList-box').on('mousewheel', function(event) {
    if (event.deltaY < 0 && sizeListTranslate > -0) {
        sizeListTranslate -= 24
        barTop += 14.4
    }
    if (event.deltaY > 0 && sizeListTranslate < 0) {
        sizeListTranslate += 24
        barTop -= 14.4
    }

    $('.sizeList').css({
        'transform': 'translateY('+sizeListTranslate+'px)'
    })
    $('.sizeList-scroll-bar').css({
        'top': barTop
    })
});

$('.sizeList-box').on('touchstart', function(e) {
    let posY = e.originalEvent.targetTouches[0].clientY
    $(this).on('touchmove', function(e) {
        let diff = e.originalEvent.targetTouches[0].clientY - posY
        if (diff < 0 && sizeListTranslate > -0) {
            sizeListTranslate -= 24
            barTop += 14.4
        }
        if (diff > 0 && sizeListTranslate < 0) {
            sizeListTranslate += 24
            barTop -= 14.4
        }

        $('.sizeList').css({
            'transform': 'translateY('+sizeListTranslate+'px)'
        })
        $('.sizeList-scroll-bar').css({
            'top': barTop
        })
    })
});

(async function(){
    if(getQueryVariable('file')){
        $('.edit_box .load').show();
        $('.edit_box>.uploadBox').hide();
        var imgFile=await fetch(getQueryVariable('file')).then(r=>r.blob()).then(
            blobFile=>{
                var file=new File([blobFile], getQueryVariable('name'), { type: getQueryVariable('type') })
                return file;
            }
        )
        var data;
        if(user){
            data={
                e_id:murmur,
                t_id:user.t_id,
                token:user.token,
                product_id:app.product_id
            }
        }else{
            data={
                e_id:murmur,
                product_id:app.product_id
            }
        }
        $.post(
            post_url+'benefit/status',
            data,
            function(data){
                console.log(data);
                error_fn(data.error);
                switch(data.error){
                    case 0:
                        app.subscriptions=data.subscriptions;
                        $('.edit_box>.uploadBox').hide();
                        window.uploadInit(imgFile);
                        break;
                    case 26801:
                        $('.image-loading-box').hide()
                        $('.alert-mask').hide();
                        error(i18n[lang].error_26801);
                        break;
                    case 26802:
                        $('.image-loading-box').hide()
                        $('.alert-mask').hide();
                        error(i18n[lang].error_26802);
                        break;
                    case 26803:
                        $('.image-loading-box').hide()
                        $('.alert-mask').hide();
                        error(i18n[lang].error_26803);
                        break;
                    case 26804:
                        $('.image-loading-box').hide()
                        $('.alert-mask').hide();
                        error(i18n[lang].error_26804);
                        break;
                }
            }
        ).fail(function(){
            $('.image-loading-box').hide()
            $('.alert-mask').hide();
            overtime(26899);
        })
    }
})();
// canvas禁止右键
$('canvas').bind('contextmenu',function(){
    return false;
});
// 禁用苹果下拉刷新
document.body.addEventListener('touchmove', function (e) {
    if(!$(e.target).parents('.scroll_box').length){
     e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果) 
    }
}, {passive: false});
// 禁止ios缩放屏幕
document.addEventListener('touchstart',function (event) {
    if(event.touches.length>1){
    event.preventDefault();
    }
});
});
